// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader";
import React, { FC } from "react";
import { connect } from "react-redux";

/* Store Custom Code - Start */
import useZoneIsActive from "@toolkit/Framework/Common/Hooks/useZoneIsActive";

const actionZoneName = "ActionButtons";
/* Store Custom Code - End */

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface OrderUploadHeaderStyles {}

export const orderUploadHeaderStyles: OrderUploadHeaderStyles = {};

const styles = orderUploadHeaderStyles;

const OrderUploadHeader: FC<Props> = ({ id, pageTitle }: Props) => {
    /* Store Custom Code - Start */
    const actionZone = useZoneIsActive(id, actionZoneName) ? <Zone contentId={id} zoneName={actionZoneName} /> : null;
    /* Store Custom Code - End */

    return <OrderHeader title={pageTitle}>{actionZone /* Store Custom Code */}</OrderHeader>;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderUploadHeader),
    definition: {
        group: "Order Upload",
        displayName: "Header",
        allowedContexts: ["OrderUploadPage"],
    },
};

export default widgetModule;
